import { useState, useEffect } from 'react'

// util fn to resolve rehydration issues on gatsby
const useIsClient = () => {
  const [isClient, setClient] = useState(false)
  useEffect(() => {
    setClient(true)
  }, [])

  return isClient
}

export default useIsClient
